import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import CustomIcon from '../../common/CustomIcon';
import CustomButton from '../../common/CustomButton';
import CustomReveal from '../../common/reveal/CustomReveal';

import * as classroomActions from '../../../actions/classroom/classroomActions';
import PanelsBottomRowButton from '../../common/PanelsBottomRowButton';

import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class SubmitTaskDataReveal extends React.Component {
  constructor(context, props) {
    super(context, props);
  }

  static propTypes = {
    active: PropTypes.bool,
    classroomActions: PropTypes.object,
    colors: PropTypes.object
  };

  sendForm = () => {
    const { classroomActions } = this.props;
    classroomActions.sendTaskData(true);
    this.closeModal();
  };

  closeModal = () => {
    const { classroomActions } = this.props;
    classroomActions.setSubmitTaskModalState(false);
  };

  render() {
    const { active } = this.props;
    let title = I18n.t('home.studentRevealTitleTask').split('.');
    return (
      <div className="modal-submit-task-z-index">
        <Modal
          id="submit-task-data-form"
          title={title[0]}
          active={active}
          onClickOutside={this.closeModal}
          children={
            <>
              <div id="submit-task-data" className="submit-task-data">
                <Paragraph className="text-grey-700">
                  {title[1]}. {title[2]}
                </Paragraph>
              </div>
            </>
          }
          footer={
            <>
              <Button id="cancel" onClick={this.closeModal} label={I18n.t('common.cancel')} />
              <Button id="primary" onClick={() => this.sendForm()} primary label={I18n.t('common.ok')} />
            </>
          }
        ></Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    active: state.classrooms.submitTaskDataIsOpen,
    colors: state.theme.colors,
    i18n: state.i18n
  };
}

function mapDispatchToProps(dispatch) {
  return {
    classroomActions: bindActionCreators(classroomActions, dispatch),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubmitTaskDataReveal);
